import gql from 'graphql-tag';

export default gql`
  mutation submitFeedback($input: SubmitFeedbackInput!) {
    submitFeedback(input: $input) {
      success
      userErrors {
        field
        message
      }
      feedback {
        id
        objectType
        submittedByUserId
        rating
        tags
        comment
        dismissedAt
        submittedAt
        createdAt
        updatedAt
      }
    }
  }
`;
